import { axiosInstance } from "../lib/axios";

// Use centralized axiosInstance which handles auth, token expiry, and interceptors
export const fetchNotifications = async (params?: {
  page?: number;
  limit?: number;
  category?: string;
  priority?: string;
  isRead?: boolean | string; // matches backend query param
  search?: string;
}) => {
  try {
    const response = await axiosInstance.get("/api/notifications", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const markNotificationAsRead = async (id: string | number) => {
  try {
    const response = await axiosInstance.put(`/api/notifications/${id}/read`, {
      isRead: true,
    });
    return response.data;
  } catch (error) {
    console.error(`Error marking notification ${id} as read:`, error);
    throw error;
  }
};

export const markAllNotificationsAsRead = async () => {
  try {
    const response = await axiosInstance.put(
      `/api/notifications/mark-all/read`,
      {},
    );
    return response.data;
  } catch (error) {
    console.error("Error marking all notifications as read:", error);
    throw error;
  }
};

export const deleteNotificationById = async (id: string | number) => {
  try {
    const response = await axiosInstance.delete(`/api/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting notification ${id}:`, error);
    throw error;
  }
};

export const clearAllNotificationsFromDB = async () => {
  try {
    const response = await axiosInstance.delete(`/api/notifications`);
    return response.data;
  } catch (error) {
    console.error("Error clearing all notifications:", error);
    throw error;
  }
};

export const getUnreadNotificationCount = async () => {
  try {
    const response = await axiosInstance.get(`/api/notifications/count/unread`);
    return response.data;
  } catch (error) {
    console.error("Error fetching unread count:", error);
    throw error;
  }
};

export const createTestNotification = async (payload: {
  notificationType: string;
  category: string;
  title?: string;
  message?: string;
  icon?: string;
  priority?: string;
  actionUrl?: string;
  actionLabel?: string;
}) => {
  try {
    const response = await axiosInstance.post(
      `/api/notifications/test`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating test notification:", error);
    throw error;
  }
};
